import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'rms-checkbox',
  standalone: true,
  templateUrl: './checkbox-field.component.html',
  styleUrls: ['../rms-styles.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxFieldComponent),
      multi: true
    }
  ]
})
export class CheckboxFieldComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() small: boolean = false;

  // The template's actual checkbox reads `value`, not a separate `_checked` field -
  // they used to be two disconnected booleans, so a plain [checked]="true" binding
  // (as opposed to ngModel/formControl, which go through writeValue()) never reached
  // the rendered checkbox at all. Unified so either way of setting it actually shows.
  @Input() get checked(): boolean {
    return this.value;
  }
  set checked(val: boolean) {
    this.value = val;
    this.onChange(val); // ✅ Notify Angular forms of the state change
  }

  value: boolean = false;
  onChange = (_: any) => { };
  onTouched = () => { };

  getCheckboxClass(): string {
    return this.small ? 'custom-checkbox-small' : 'custom-checkbox';
  }

  writeValue(value: any): void {
    this.value = value ?? false;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  toggleCheckbox() {
    if (!this.disabled) {
      this.value = !this.value;
      this.onChange(this.value);
      this.onTouched();
    }
  }
}
